import { Skeleton } from "@/components/ui/skeleton";
import { Heart, BookMarked } from "lucide-react";

export function ProfileSkeleton() {
  return (
     <div className="container mx-auto max-w-5xl">
        <div className="flex flex-col md:flex-row items-center gap-6 mb-12">
            <Skeleton className="h-24 w-24 rounded-full border-4 border-primary" />
            <div>
                <Skeleton className="h-10 w-64" />
                <Skeleton className="h-5 w-80 mt-2" />
            </div>
        </div>
         <div className="space-y-12">
            <div>
              <h2 className="text-2xl font-semibold flex items-center gap-2 mb-6">
                <Heart className="h-6 w-6 text-accent" />
                Favorite Spots
              </h2>
              <p className="text-muted-foreground">No favorite spots saved yet. This feature is coming soon!</p>
            </div>
             <div>
              <h2 className="text-2xl font-semibold flex items-center gap-2 mb-6">
                <BookMarked className="h-6 w-6 text-primary" />
                Swim Log
              </h2>
               <p className="text-muted-foreground">No swims logged yet. This feature is coming soon!</p>
             </div>
        </div>
    </div>
  )
}
